import { useState, useEffect } from 'react';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-white/10 backdrop-blur-md'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          {/* Logo - Increased size by 20% */}
          <div className="flex-shrink-0 bg-white/95 backdrop-blur-sm rounded-lg px-4 py-2 shadow-md">
            <img 
              src="https://lirp.cdn-website.com/3dbb45be/dms3rep/multi/opt/o--2846-29-1920w.png" 
              alt="A-One Solid Surfacing Logo" 
              className="h-20 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <button onClick={() => scrollToSection('services')} className={`text-sm font-semibold transition-colors hover:text-amber-600 ${isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'}`}>
              Services
            </button>
            <button onClick={() => scrollToSection('why-choose')} className={`text-sm font-semibold transition-colors hover:text-amber-600 ${isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'}`}>
              Why Choose Us
            </button>
            <button onClick={() => scrollToSection('gallery')} className={`text-sm font-semibold transition-colors hover:text-amber-600 ${isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'}`}>
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-semibold transition-colors hover:text-amber-600 ${isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'}`}>
              Reviews
            </button>
            <button onClick={() => scrollToSection('service-areas')} className={`text-sm font-semibold transition-colors hover:text-amber-600 ${isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'}`}>
              Service Areas
            </button>
            <button onClick={() => scrollToSection('faq')} className={`text-sm font-semibold transition-colors hover:text-amber-600 ${isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'}`}>
              FAQ
            </button>
          </nav>

          {/* CTA Buttons */}
          <div className="hidden lg:flex items-center space-x-4">
            <a href="tel:801-706-1610" className={`flex items-center space-x-2 text-sm font-semibold transition-colors hover:text-amber-600 ${isScrolled ? 'text-gray-900' : 'text-white drop-shadow-lg'}`}>
              <i className="ri-phone-line text-lg"></i>
              <span>801-706-1610</span>
            </a>
            <button 
              onClick={() => scrollToSection('contact-form')}
              className="bg-amber-600 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-amber-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              Request Estimate
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 bg-white/95 rounded-lg shadow-md"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-900`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-6 space-y-4">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left text-gray-900 font-medium py-2 hover:text-amber-600">
              Services
            </button>
            <button onClick={() => scrollToSection('why-choose')} className="block w-full text-left text-gray-900 font-medium py-2 hover:text-amber-600">
              Why Choose Us
            </button>
            <button onClick={() => scrollToSection('gallery')} className="block w-full text-left text-gray-900 font-medium py-2 hover:text-amber-600">
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left text-gray-900 font-medium py-2 hover:text-amber-600">
              Reviews
            </button>
            <button onClick={() => scrollToSection('service-areas')} className="block w-full text-left text-gray-900 font-medium py-2 hover:text-amber-600">
              Service Areas
            </button>
            <button onClick={() => scrollToSection('faq')} className="block w-full text-left text-gray-900 font-medium py-2 hover:text-amber-600">
              FAQ
            </button>
            <a href="tel:801-706-1610" className="flex items-center space-x-2 text-gray-900 font-medium py-2 hover:text-amber-600">
              <i className="ri-phone-line text-lg"></i>
              <span>801-706-1610</span>
            </a>
            <button 
              onClick={() => scrollToSection('contact-form')}
              className="w-full bg-amber-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-amber-700 transition-all whitespace-nowrap"
            >
              Request Estimate
            </button>
          </div>
        </div>
      )}
    </header>
  );
}